import Dialog from "meta/ui2/dialog";
import { DialogManager } from "meta/ui2/dialog/DialogManager";
import { useEffect } from "react";
import { useAuditer } from "./useAuditer";
import { useChartTabsAPI } from "./useChartTabsAPI";
import { useFrameSessionResolver } from "./useFrameSessionResolver";
import { useContentTabs } from "./useContentTabs";
import { useNavigation } from "./useNavigation";
import { useUser } from "./useUser";
import HotkeysManager from "meta/extensions/hotkeys/manager";
import HotkeysClient from "meta/extensions/hotkeys/client";
import utilityFunctions from "../../lib/global-functions/utils";
import { useUserActivity } from "./useUserActivity";
import { useAppSelector } from "../useAppSelector";
import { useHeadlessMode } from "../useHeadlessModeEnabled";
import { useFocus } from "./useFocus";
import { getParentWindow } from "meta/utils/getParentWindow";
import { getRootAppWindow } from "meta/utils/getRootAppWindow";
import FrontendEvents from "screens/Root/features/frontendEvents";
window.RootAPI = {
    FrontendEvents,
    FrameSessionResolver: { resolve() { } },
};
export const useRootAPI = () => {
    const publicRootState = useAppSelector((state) => state.rootPublicState);
    const Auditer = useAuditer();
    const FrameSessionResolver = useFrameSessionResolver();
    const ContentTabs = useContentTabs();
    const ChartTabs = useChartTabsAPI();
    const Navigation = useNavigation();
    const User = useUser();
    const userActivity = useUserActivity();
    const HeadlessMode = useHeadlessMode();
    const Focus = useFocus();
    useEffect(() => {
        window.RootAPI = {
            //Do not use this property directly! Please use DialogManger instead.
            GlobalDialog: Dialog,
            ContentTabs,
            ChartTabs,
            Navigation,
            FrameSessionResolver,
            Auditer,
            FrontendEvents,
            User,
            HeadlessMode,
            Focus,
        };
        window.RootState = publicRootState;
    });
    useEffect(() => {
        window.name = "top";
        window.HKManager = new HotkeysManager();
        window.Hotkeys = new HotkeysClient();
        Object.defineProperties(window, {
            DialogManager: { get: DialogManager },
            ParentWindow: { get: () => getParentWindow(window) },
            RootWindow: { get: () => getRootAppWindow(window) }
        });
        Object.assign(window, utilityFunctions);
        userActivity.inititalize();
    }, []);
};
